class TabsAutomatic {
	constructor(groupNode) {
		this.tablistNode = groupNode;

		this.tabs = [];

		this.firstTab = null;
		this.lastTab = null;

		this.tabs = Array.from(this.tablistNode.querySelectorAll('[role=tab]'));
		this.tabpanels = [];

		this.tabs.forEach((tab) => {
			const tabpanel = document.getElementById(
				tab.getAttribute('aria-controls')
			);

			tab.tabIndex = -1;
			tab.setAttribute('aria-selected', 'false');
			this.tabpanels.push(tabpanel);

			tab.addEventListener('keydown', this.onKeydown.bind(this));
			tab.addEventListener('click', this.onClick.bind(this));

			if (!this.firstTab) {
				this.firstTab = tab;
			}
			this.lastTab = tab;
		});

		this.setSelectedTab(this.firstTab, false);
	}

	setSelectedTab(currentTab, setFocus) {
		if (typeof setFocus !== 'boolean') {
			setFocus = true;
		}
		for (let i = 0; i < this.tabs.length; i += 1) {
			const tab = this.tabs[i];
			if (currentTab === tab) {
				tab.setAttribute('aria-selected', 'true');
				tab.removeAttribute('tabindex');
				this.tabpanels[i].classList.remove('is-hidden');
				if (setFocus) {
					tab.focus();
				}
			} else {
				tab.setAttribute('aria-selected', 'false');
				tab.tabIndex = -1;
				this.tabpanels[i].classList.add('is-hidden');
			}
		}
	}

	setSelectedToPreviousTab(currentTab) {
		let index;

		if (currentTab === this.firstTab) {
			this.setSelectedTab(this.lastTab);
		} else {
			index = this.tabs.indexOf(currentTab);
			this.setSelectedTab(this.tabs[index - 1]);
		}
	}

	setSelectedToNextTab(currentTab) {
		let index;

		if (currentTab === this.lastTab) {
			this.setSelectedTab(this.firstTab);
		} else {
			index = this.tabs.indexOf(currentTab);
			this.setSelectedTab(this.tabs[index + 1]);
		}
	}

	/* EVENT HANDLERS */
	onKeydown(event) {
		const tgt = event.currentTarget;
		let flag = false;

		switch (event.key) {
			case 'ArrowLeft':
				this.setSelectedToPreviousTab(tgt);
				flag = true;
				break;

			case 'ArrowRight':
				this.setSelectedToNextTab(tgt);
				flag = true;
				break;

			case 'Home':
				this.setSelectedTab(this.firstTab);
				flag = true;
				break;

			case 'End':
				this.setSelectedTab(this.lastTab);
				flag = true;
				break;

			default:
				break;
		}

		if (flag) {
			event.stopPropagation();
			event.preventDefault();
		}
	}

	onClick(event) {
		this.setSelectedTab(event.currentTarget);
	}
}

class Dialog {
	constructor(dialog, dialogOpener, dialogCloser) {
		this.dialog = dialog;
		this.dialogOpener = dialogOpener;

		this.iframe = dialog.querySelector('iframe');

		dialogOpener.addEventListener('click', this.openModal.bind(this));
		dialogCloser.addEventListener('click', this.closeModal.bind(this));
	}

	openModal() {
		this.dialog.showModal();
	}

	closeModal() {
		if (this.iframe) {
			// Stop any media playing from the iframe when the modal is closed.
			const iframeSrc = this.iframe.getAttribute('src');
			this.iframe.removeAttribute('src');
			setTimeout(() => {
				this.iframe.setAttribute('src', iframeSrc);
			}, 500);
		}

		// Close the dialog
		this.dialog.close();
	}
}

const throttle = (fn, time) => {
	let timeout = null;
	return function () {
		if (timeout) {
			return;
		}
		const context = this;
		const args = arguments;
		const later = () => {
			fn.call(context, ...args);
			timeout = null;
		};
		timeout = setTimeout(later, time);
	};
};

export { TabsAutomatic, Dialog, throttle };
